import { render } from "./ClientManagerDashboardOverview.vue?vue&type=template&id=1b407c24"
import script from "./ClientManagerDashboardOverview.vue?vue&type=script&lang=js"
export * from "./ClientManagerDashboardOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__